export const BUTTON_BASE_CLASSES =
  "flex w-fit cursor-pointer items-center justify-center whitespace-nowrap";

export const BUTTON_SQUIRCLE_CLASSES = "supports-[(corner-shape:squircle)]:[corner-shape:squircle]";

export const BUTTON_DISABLED_CLASSES =
  "disabled:cursor-not-allowed disabled:text-black-tint-55 disabled:bg-black-tint-97 disabled:border-black-tint-90 " +
  "disabled:group-data-[dark]/themable:text-black-tint-40 disabled:group-data-[dark]/themable:bg-black-tint-20 disabled:group-data-[dark]/themable:border-black-tint-20";

export const BUTTON_PRIMARY_CLASSES =
  "text-white bg-black-tint-20 border-black-tint-20 " +
  "hover:bg-black-tint-30 hover:border-black-tint-30 " +
  "active:bg-black-tint-30 active:border-black-tint-55 " +
  "data-[selected]:bg-black-tint-30 data-[selected]:border-black-tint-55 " +
  "data-[selected]:hover:bg-black-tint-20 data-[selected]:hover:border-black-tint-40";

export const BUTTON_SECONDARY_CLASSES =
  "text-black-tint-20 bg-black-tint-97 border-black-tint-97 " +
  "hover:text-blue-shade-40 hover:bg-blue-tint-93 hover:border-blue-tint-93 " +
  "active:text-blue-shade-40 active:bg-blue-tint-90 active:border-blue-tint-40 " +
  "data-[selected]:text-blue-shade-40 data-[selected]:bg-blue-tint-90 data-[selected]:border-blue-tint-40 " +
  "data-[selected]:hover:bg-blue-tint-93 data-[selected]:hover:border-blue-tint-70 " +
  "group-data-[dark]/themable:text-white group-data-[dark]/themable:bg-black-tint-20 group-data-[dark]/themable:border-black-tint-20 " +
  "group-data-[dark]/themable:hover:bg-black-tint-30 group-data-[dark]/themable:hover:border-black-tint-30 " +
  "group-data-[dark]/themable:active:bg-blue-shade-40 group-data-[dark]/themable:active:border-blue " +
  "group-data-[dark]/themable:data-[selected]:bg-blue-shade-40 group-data-[dark]/themable:data-[selected]:border-blue " +
  "group-data-[dark]/themable:data-[selected]:hover:bg-blue-shade-20 group-data-[dark]/themable:data-[selected]:hover:border-blue-tint-20";

export const BUTTON_TERTIARY_CLASSES =
  "text-black-tint-20 bg-black-tint-99 border-black-tint-90 " +
  "hover:bg-black-tint-97 " +
  "active:bg-black-tint-97 active:border-black-tint-70 " +
  "data-[selected]:bg-black-tint-97 data-[selected]:border-black-tint-70 " +
  "data-[selected]:hover:bg-black-tint-97 data-[selected]:hover:border-black-tint-86 " +
  "group-data-[dark]/themable:text-white group-data-[dark]/themable:bg-black-tint-20 group-data-[dark]/themable:border-black-tint-20 " +
  "group-data-[dark]/themable:hover:bg-black-tint-30 group-data-[dark]/themable:hover:border-black-tint-30 " +
  "group-data-[dark]/themable:active:bg-black-tint-30 group-data-[dark]/themable:active:border-black-tint-55 " +
  "group-data-[dark]/themable:data-[selected]:bg-black-tint-30 group-data-[dark]/themable:data-[selected]:border-black-tint-55 " +
  "group-data-[dark]/themable:data-[selected]:hover:bg-black-tint-20 group-data-[dark]/themable:data-[selected]:hover:border-black-tint-40";

export const BUTTON_GHOST_CLASSES =
  "text-black-tint-20 bg-transparent border-transparent " +
  "hover:bg-black-tint-97 hover:border-black-tint-90 " +
  "active:bg-black-tint-97 active:border-black-tint-70 " +
  "data-[selected]:bg-black-tint-97 data-[selected]:border-black-tint-70 " +
  "data-[selected]:hover:bg-black-tint-97 data-[selected]:hover:border-black-tint-86";

export const BUTTON_ACCENT_CLASSES =
  "text-white bg-blue-shade-20 border-blue-shade-20 " +
  "hover:text-white hover:bg-blue hover:border-blue " +
  "active:bg-blue-shade-20 active:border-blue-tint-20 " +
  "data-[selected]:bg-blue-shade-20 data-[selected]:border-blue-tint-20 " +
  "data-[selected]:hover:bg-blue data-[selected]:hover:border-blue-tint-40 ";

export const BUTTON_SUCCESS_CLASSES =
  "text-white bg-green-shade-20 border-green-shade-20 " +
  "hover:bg-green hover:border-green " +
  "active:bg-green-shade-20 active:border-green-tint-20 " +
  "data-[selected]:bg-green-shade-20 data-[selected]:border-green-tint-20 " +
  "data-[selected]:hover:bg-green data-[selected]:hover:border-green-tint-70";

export const BUTTON_CAUTION_CLASSES =
  "text-red-shade-20 bg-red-tint-95 border-red-tint-95 " +
  "hover:text-red hover:bg-red-tint-93 hover:border-red-tint-70 " +
  "active:bg-red-tint-90 active:border-red-tint-40 " +
  "data-[selected]:bg-red-tint-90 data-[selected]:border-red-tint-40 " +
  "data-[selected]:text-red data-[selected]:hover:bg-red-tint-93 data-[selected]:hover:border-red-tint-80";

export const BUTTON_TOGGLE_CLASSES =
  "text-black-tint-20 bg-black-tint-97 border-black-tint-97 " +
  "hover:text-blue-shade-40 hover:bg-blue-tint-93 hover:border-blue-tint-93 " +
  "active:text-blue-shade-40 active:bg-blue-tint-90 active:border-blue-tint-40 " +
  "data-[selected]:text-blue-shade-40 data-[selected]:bg-blue-tint-90 data-[selected]:border-blue-tint-40 " +
  "data-[selected]:hover:bg-blue-tint-93 data-[selected]:hover:border-blue-tint-70 " +
  "group-data-[dark]/themable:text-white group-data-[dark]/themable:bg-black-tint-20 group-data-[dark]/themable:border-black-tint-20 " +
  "group-data-[dark]/themable:hover:bg-black-tint-30 group-data-[dark]/themable:hover:border-black-tint-30 " +
  "group-data-[dark]/themable:active:bg-black-tint-30 group-data-[dark]/themable:active:border-black-tint-55 " +
  "group-data-[dark]/themable:data-[selected]:bg-black-tint-30 group-data-[dark]/themable:data-[selected]:border-black-tint-55 " +
  "group-data-[dark]/themable:data-[selected]:hover:bg-black-tint-20 group-data-[dark]/themable:data-[selected]:hover:border-black-tint-40";
